import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Partner } from "../../../shared/models/partner";
import { PartnerService } from "../../../shared/services/api/partner.service";
import { NotificationService } from "../../../shared/services/notification.service";

export interface PartnerVatInfoDialogData {
  readonly partner: Partner;
}

export type PartnerVatInfoDialogResult = Partner;

@Component({
  selector: "app-partner-vat-info-dialog",
  templateUrl: "./partner-vat-info-dialog.component.html",
  styleUrl: "./partner-vat-info-dialog.component.scss",
})
export class PartnerVatInfoDialogComponent {
  protected saving = false;
  protected partner: Partner;

  constructor(
    private readonly partnerService: PartnerService,
    private readonly notificationService: NotificationService,
    private readonly dialogRef: MatDialogRef<
      PartnerVatInfoDialogComponent,
      PartnerVatInfoDialogResult
    >,
    @Inject(MAT_DIALOG_DATA) data: PartnerVatInfoDialogData,
  ) {
    this.partner = data.partner;
  }

  protected updatePartner(): void {
    this.saving = true;

    this.partnerService.update(this.partner).subscribe({
      next: (partner: Partner) => {
        this.saving = false;
        this.partner.vatNumber = partner.vatNumber;
        this.dialogRef.close(this.partner);
      },
      error: () => {
        this.saving = false;
        this.notificationService.error("shared.changesCouldNotBeSaved");
      },
    });
  }
}
